
import { Base } from '../base-component';
import './pagination.component.scss';

export class Pagination extends Base {

	constructor(element: Element ) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/pagination/pagination.component.ts